export default __webpack_public_path__ + "static/media/Friction2AImg.ad032a3a.jpg";